















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"])
})
export default class TabNav extends Vue {
    @Prop({ type: Array })
    tabs!: DataTable.DropItem[];

    @Prop({ type: Object })
    activeTab!: DataTable.DropItem;

    clickTab(tab: DataTable.DropItem, index: number) {
        this.$emit("update:activeTab", tab);
        this.$emit("change", tab);
    }
}
